export const HELPERS_MENU_OPEN = 'HELPERS_MENU_OPEN';
export const HELPERS_MENU_CLOSE = 'HELPERS_MENU_CLOSE';
export const HELPERS_BLUR_APPEND = 'HELPERS_BLUR_APPEND';
export const HELPERS_BLUR_REMOVE = 'HELPERS_BLUR_REMOVE';

export const HELPERS_NOTIFICATIONS_MACHINES_FETCH_START = 'HELPERS_NOTIFICATIONS_MACHINES_FETCH_START';
export const HELPERS_NOTIFICATIONS_MACHINES_FETCH_SUCCESS = 'HELPERS_NOTIFICATIONS_MACHINES_FETCH_SUCCESS';
export const HELPERS_NOTIFICATIONS_MACHINES_FETCH_FAIL = 'HELPERS_NOTIFICATIONS_MACHINES_FETCH_FAIL';

export const HELPERS_COUNTRIES_STATES_FETCH_START = 'HELPERS_COUNTRIES_STATES_FETCH_START';
export const HELPERS_COUNTRIES_STATES_FETCH_SUCCESS = 'HELPERS_COUNTRIES_STATES_FETCH_SUCCESS';
export const HELPERS_COUNTRIES_STATES_FETCH_FAIL = 'HELPERS_COUNTRIES_STATES_FETCH_FAIL';

export const HELPERS_DESIGNUPLOAD_START = 'HELPERS_DESIGNUPLOAD_START';
export const HELPERS_DESIGNUPLOAD_SUCCESS = 'HELPERS_DESIGNUPLOAD_SUCCESS';
export const HELPERS_DESIGNUPLOAD_RESET = 'HELPERS_DESIGNUPLOAD_RESET';
export const HELPERS_DESIGNUPLOAD_FAIL = 'HELPERS_DESIGNUPLOAD_FAIL';
export const HELPERS_DESIGNUPLOAD_PROGRESS = 'HELPERS_DESIGNUPLOAD_PROGRESS';

export const AUTH_SET_MELCO_ACCOUNT_DATA = 'AUTH_SET_MELCO_ACCOUNT_DATA';
export const AUTH_REMOVE_MELCO_ACCOUNT_DATA = 'AUTH_REMOVE_MELCO_ACCOUNT_DATA';
export const AUTH_CHANGE_CURRENT_USER = 'AUTH_CHANGE_CURRENT_USER';
export const AUTH_LOGOUT_ON_SERVER_START = 'AUTH_LOGOUT_ON_SERVER_START';
export const AUTH_LOGOUT_ON_SERVER_SUCCESS = 'AUTH_LOGOUT_ON_SERVER_SUCCESS';
export const AUTH_LOGOUT_ON_SERVER_FAIL = 'AUTH_LOGOUT_ON_SERVER_FAIL';

export const TOKEN_RESTORE_START = 'TOKEN_RESTORE_START';
export const TOKEN_RESTORE_SUCCESS = 'TOKEN_RESTORE_SUCCESS';
export const TOKEN_RESTORE_FAIL = 'TOKEN_RESTORE_FAIL';

export const APP_STARTUP_START = 'APP_STARTUP_START';
export const APP_STARTUP_SUCCESS = 'APP_STARTUP_SUCCESS';
export const APP_STARTUP_FAIL = 'APP_STARTUP_FAIL';

export const TRANSLATION_LOAD_START = 'TRANSLATION_LOAD_START';
export const TRANSLATION_LOAD_SUCCESS = 'TRANSLATION_LOAD_SUCCESS';
export const TRANSLATION_LOAD_FAIL = 'TRANSLATION_LOAD_FAIL';

export const DEFAULTS_GET = 'DEFAULTS_GET';
export const DEFAULTS_FETCH_START = 'DEFAULTS_FETCH_START';
export const DEFAULTS_FETCH_SUCCESS = 'DEFAULTS_FETCH_SUCCESS';
export const DEFAULTS_FETCH_FAIL = 'DEFAULTS_FETCH_FAIL';

export const SETTINGS_COMPANY_UPDATE_START = 'SETTINGS_COMPANY_UPDATE_START';
export const SETTINGS_COMPANY_UPDATE_SUCCESS = 'SETTINGS_COMPANY_UPDATE_SUCCESS';
export const SETTINGS_COMPANY_UPDATE_FAIL = 'SETTINGS_COMPANY_UPDATE_FAIL';
export const SETTINGS_COMPANY_UPDATE_RESET = 'SETTINGS_COMPANY_UPDATE_RESET';
export const SETTINGS_COMPANY_FETCH_START = 'SETTINGS_COMPANY_FETCH_START';
export const SETTINGS_COMPANY_FETCH_SUCCESS = 'SETTINGS_COMPANY_FETCH_SUCCESS';
export const SETTINGS_COMPANY_FETCH_FAIL = 'SETTINGS_COMPANY_FETCH_FAIL';
export const SETTINGS_COMPANY_FETCH_RESET = 'SETTINGS_COMPANY_FETCH_RESET';

export const CALCULATOR_JOBS_FETCH_START = 'CALCULATOR_JOBS_FETCH_START';
export const CALCULATOR_JOBS_FETCH_SUCCESS = 'CALCULATOR_JOBS_FETCH_SUCCESS';
export const CALCULATOR_JOBS_FETCH_FAIL = 'CALCULATOR_JOBS_FETCH_FAIL';
export const CALCULATOR_JOBS_DEFAULTS_FETCH_START = 'CALCULATOR_JOBS_DEFAULTS_FETCH_START';
export const CALCULATOR_JOBS_DEFAULTS_FETCH_SUCCESS = 'CALCULATOR_JOBS_DEFAULTS_FETCH_SUCCESS';
export const CALCULATOR_JOBS_DEFAULTS_FETCH_FAIL = 'CALCULATOR_JOBS_DEFAULTS_FETCH_FAIL';
export const CALCULATOR_JOBS_DEFAULTS_UPDATE_START = 'CALCULATOR_JOBS_DEFAULTS_UPDATE_START';
export const CALCULATOR_JOBS_DEFAULTS_UPDATE_SUCCESS = 'CALCULATOR_JOBS_DEFAULTS_UPDATE_SUCCESS';
export const CALCULATOR_JOBS_DEFAULTS_UPDATE_FAIL = 'CALCULATOR_JOBS_DEFAULTS_UPDATE_FAIL';
export const CALCULATOR_JOBS_DEFAULTS_UPDATE_RESET = 'CALCULATOR_JOBS_DEFAULTS_UPDATE_RESET';

export const CALCULATOR_JOB_CREATE_START = 'CALCULATOR_JOB_CREATE_START';
export const CALCULATOR_JOB_CREATE_SUCCESS = 'CALCULATOR_JOB_CREATE_SUCCESS';
export const CALCULATOR_JOB_CREATE_FAIL = 'CALCULATOR_JOB_CREATE_FAIL';
export const CALCULATOR_JOB_CREATE_RESET = 'CALCULATOR_JOB_CREATE_RESET';
export const CALCULATOR_JOB_DUPLICATECHECK_START = 'CALCULATOR_JOB_DUPLICATECHECK_START';
export const CALCULATOR_JOB_DUPLICATECHECK_SUCCESS = 'CALCULATOR_JOB_DUPLICATECHECK_SUCCESS';
export const CALCULATOR_JOB_DUPLICATECHECK_FAIL = 'CALCULATOR_JOB_DUPLICATECHECK_FAIL';
export const CALCULATOR_JOB_DUPLICATECHECK_RESET = 'CALCULATOR_JOB_DUPLICATECHECK_RESET';
export const CALCULATOR_JOB_FETCH_START = 'CALCULATOR_JOB_FETCH_START';
export const CALCULATOR_JOB_FETCH_SUCCESS = 'CALCULATOR_JOB_FETCH_SUCCESS';
export const CALCULATOR_JOB_FETCH_FAIL = 'CALCULATOR_JOB_FETCH_FAIL';
export const CALCULATOR_JOB_FETCH_RESET = 'CALCULATOR_JOB_FETCH_RESET';
export const CALCULATOR_JOB_MESSAGE_SET = 'CALCULATOR_JOB_MESSAGE_SET';
export const CALCULATOR_JOB_MESSAGE_RESET = 'CALCULATOR_JOB_MESSAGE_RESET';
export const CALCULATOR_JOB_UPDATE_START = 'CALCULATOR_JOB_UPDATE_START';
export const CALCULATOR_JOB_UPDATE_SUCCESS = 'CALCULATOR_JOB_UPDATE_SUCCESS';
export const CALCULATOR_JOB_UPDATE_FAIL = 'CALCULATOR_JOB_UPDATE_FAIL';
export const CALCULATOR_JOB_UPDATE_RESET = 'CALCULATOR_JOB_UPDATE_RESET';
export const CALCULATOR_JOB_MACHINE_UPDATE_START = 'CALCULATOR_JOB_MACHINE_UPDATE_START';
export const CALCULATOR_JOB_MACHINE_UPDATE_SUCCESS = 'CALCULATOR_JOB_MACHINE_UPDATE_SUCCESS';
export const CALCULATOR_JOB_MACHINE_UPDATE_FAIL = 'CALCULATOR_JOB_MACHINE_UPDATE_FAIL';
export const CALCULATOR_JOB_MACHINE_UPDATE_RESET = 'CALCULATOR_JOB_MACHINE_UPDATE_RESET';
export const CALCULATOR_JOB_MACHINE_FETCH_START = 'CALCULATOR_JOB_MACHINE_FETCH_START';
export const CALCULATOR_JOB_MACHINE_FETCH_SUCCESS = 'CALCULATOR_JOB_MACHINE_FETCH_SUCCESS';
export const CALCULATOR_JOB_MACHINE_FETCH_FAIL = 'CALCULATOR_JOB_MACHINE_FETCH_FAIL';
export const CALCULATOR_JOB_MACHINE_FETCH_RESET = 'CALCULATOR_JOB_MACHINE_FETCH_RESET';
export const CALCULATOR_JOB_CALCULATIONS_FETCH_START = 'CALCULATOR_JOB_CALCULATIONS_FETCH_START';
export const CALCULATOR_JOB_CALCULATIONS_FETCH_SUCCESS = 'CALCULATOR_JOB_CALCULATIONS_FETCH_SUCCESS';
export const CALCULATOR_JOB_CALCULATIONS_FETCH_FAIL = 'CALCULATOR_JOB_CALCULATIONS_FETCH_FAIL';
export const CALCULATOR_JOB_CALCULATIONS_FETCH_RESET = 'CALCULATOR_JOB_CALCULATIONS_FETCH_RESET';
export const CALCULATOR_JOB_EXPORT_FETCH_START = 'CALCULATOR_JOB_EXPORT_FETCH_START';
export const CALCULATOR_JOB_EXPORT_FETCH_SUCCESS = 'CALCULATOR_JOB_EXPORT_FETCH_SUCCESS';
export const CALCULATOR_JOB_EXPORT_FETCH_FAIL = 'CALCULATOR_JOB_EXPORT_FETCH_FAIL';
export const CALCULATOR_JOB_EXPORT_FETCH_RESET = 'CALCULATOR_JOB_EXPORT_FETCH_RESET';
export const CALCULATOR_JOB_DELETE_START = 'CALCULATOR_JOB_DELETE_START';
export const CALCULATOR_JOB_DELETE_SUCCESS = 'CALCULATOR_JOB_DELETE_SUCCESS';
export const CALCULATOR_JOB_DELETE_FAIL = 'CALCULATOR_JOB_DELETE_FAIL';
export const CALCULATOR_JOB_DELETE_RESET = 'CALCULATOR_JOB_DELETE_RESET';
export const CALCULATOR_JOB_CHANGEACTIVE_START = 'CALCULATOR_JOB_CHANGEACTIVE_START';
export const CALCULATOR_JOB_CHANGEACTIVE_SUCCESS = 'CALCULATOR_JOB_CHANGEACTIVE_SUCCESS';
export const CALCULATOR_JOB_CHANGEACTIVE_FAIL = 'CALCULATOR_JOB_CHANGEACTIVE_FAIL';
export const CALCULATOR_JOB_CHANGEACTIVE_RESET = 'CALCULATOR_JOB_CHANGEACTIVE_RESET';
export const CALCULATOR_JOB_RECALCULATE_START = 'CALCULATOR_JOB_RECALCULATE_START';
export const CALCULATOR_JOB_RECALCULATE_SUCCESS = 'CALCULATOR_JOB_RECALCULATE_SUCCESS';
export const CALCULATOR_JOB_RECALCULATE_FAIL = 'CALCULATOR_JOB_RECALCULATE_FAIL';
export const CALCULATOR_JOB_RECALCULATE_RESET = 'CALCULATOR_JOB_RECALCULATE_RESET';
export const CALCULATOR_JOB_DETAILED_CALCULATION_START = 'CALCULATOR_JOB_DETAILED_CALCULATION_START';
export const CALCULATOR_JOB_DETAILED_CALCULATION_SUCCESS = 'CALCULATOR_JOB_DETAILED_CALCULATION_SUCCESS';
export const CALCULATOR_JOB_DETAILED_CALCULATION_FAIL = 'CALCULATOR_JOB_DETAILED_CALCULATION_FAIL';
export const CALCULATOR_JOB_DETAILED_CALCULATION_RESET = 'CALCULATOR_JOB_DETAILED_CALCULATION_RESET';

export const CALCULATOR_MACHINES_FETCH_START = 'CALCULATOR_MACHINES_FETCH_START';
export const CALCULATOR_MACHINES_FETCH_SUCCESS = 'CALCULATOR_MACHINES_FETCH_SUCCESS';
export const CALCULATOR_MACHINES_FETCH_FAIL = 'CALCULATOR_MACHINES_FETCH_FAIL';
export const CALCULATOR_MACHINES_DEFAULTS_FETCH_START = 'CALCULATOR_MACHINES_DEFAULTS_FETCH_START';
export const CALCULATOR_MACHINES_DEFAULTS_FETCH_SUCCESS = 'CALCULATOR_MACHINES_DEFAULTS_FETCH_SUCCESS';
export const CALCULATOR_MACHINES_DEFAULTS_FETCH_FAIL = 'CALCULATOR_MACHINES_DEFAULTS_FETCH_FAIL';
export const CALCULATOR_MACHINE_CREATE_START = 'CALCULATOR_MACHINE_CREATE_START';
export const CALCULATOR_MACHINE_CREATE_SUCCESS = 'CALCULATOR_MACHINE_CREATE_SUCCESS';
export const CALCULATOR_MACHINE_CREATE_FAIL = 'CALCULATOR_MACHINE_CREATE_FAIL';
export const CALCULATOR_MACHINE_CREATE_RESET = 'CALCULATOR_MACHINE_CREATE_RESET';
export const CALCULATOR_MACHINE_FETCH_START = 'CALCULATOR_MACHINE_FETCH_START';
export const CALCULATOR_MACHINE_FETCH_SUCCESS = 'CALCULATOR_MACHINE_FETCH_SUCCESS';
export const CALCULATOR_MACHINE_FETCH_FAIL = 'CALCULATOR_MACHINE_FETCH_FAIL';
export const CALCULATOR_MACHINE_FETCH_RESET = 'CALCULATOR_MACHINE_FETCH_RESET';
export const CALCULATOR_MACHINE_UPDATE_START = 'CALCULATOR_MACHINE_UPDATE_START';
export const CALCULATOR_MACHINE_UPDATE_SUCCESS = 'CALCULATOR_MACHINE_UPDATE_SUCCESS';
export const CALCULATOR_MACHINE_UPDATE_FAIL = 'CALCULATOR_MACHINE_UPDATE_FAIL';
export const CALCULATOR_MACHINE_UPDATE_RESET = 'CALCULATOR_MACHINE_UPDATE_RESET';
export const CALCULATOR_MACHINE_DELETE_START = 'CALCULATOR_MACHINE_DELETE_START';
export const CALCULATOR_MACHINE_DELETE_SUCCESS = 'CALCULATOR_MACHINE_DELETE_SUCCESS';
export const CALCULATOR_MACHINE_DELETE_FAIL = 'CALCULATOR_MACHINE_DELETE_FAIL';
export const CALCULATOR_MACHINE_DELETE_RESET = 'CALCULATOR_MACHINE_DELETE_RESET';
export const CALCULATOR_MACHINE_DUPLICATECHECK_START = 'CALCULATOR_MACHINE_DUPLICATECHECK_START';
export const CALCULATOR_MACHINE_DUPLICATECHECK_SUCCESS = 'CALCULATOR_MACHINE_DUPLICATECHECK_SUCCESS';
export const CALCULATOR_MACHINE_DUPLICATECHECK_FAIL = 'CALCULATOR_MACHINE_DUPLICATECHECK_FAIL';
export const CALCULATOR_MACHINE_DUPLICATECHECK_RESET = 'CALCULATOR_MACHINE_DUPLICATECHECK_RESET';

export const FETCHING = 'FETCHING';
export const NOT_FETCHING = 'NOT_FETCHING';

export const PRINTING = 'PRINTING';
export const NOT_PRINTING = 'NOT_PRINTING';

export const VISUALMESSAGE_RESET = 'VISUALMESSAGE_RESET';
export const VISUALMESSAGE_SET = 'VISUALMESSAGE_SET';



// WEBPACK FOOTER //
// ./src/_store/actions/actionTypes.js